// extracted by mini-css-extract-plugin
export var albumList = "styles-module--albumList--3YCjO";
export var albumLink = "styles-module--albumLink--3OUxH";
export var titleImage = "styles-module--titleImage--1ZQiA";
export var title = "styles-module--title--3cgs4";